<template>
  <div class="row text-dark" style="margin: 0">
    <div class="col-md-12 desc">
      <div>
        <ul class="p-0 w-100">
          <li
            v-for="(group, index) in items"
            :key="index"
            class="p-2 c-pointer parent-li border-top"
          >
            <div class="row align-items-center">
              <div class="text-primary d-flex align-items-center">
                <Checkbox
                  v-model="group.displayCheck"
                  :binary="true"
                  class="all-check"
                  @change="getCheckedGroup(group)"
                />
                <i
                  v-if="group.children && group.children.length > 0"
                  class="pi pi-chevron-down ml-3"
                  :class="{ 'roll-icon': !group.expanded }"
                  @click="group.expanded = !group.expanded"
                ></i>
              </div>
              <div class="text-primary ml-3">
                <span>{{ group.name }}</span>
              </div>
            </div>

            <!-- Recursive children -->
            <div v-show="group.expanded" class="ml-4">
              <GroupTree
                :items="group.children"
                v-if="group.children"
                @group="emitGroup"
                @newgroup="emitNewGroup"
              />
            </div>
          </li>

          <li
            v-if="onDropDown"
            class="shadow-sm text-center border p-2 font-weight-700 c-pointer"
            @click="openCreateGroupModal"
          >
            <i class="pi pi-plus-circle"></i>&nbsp;Add new group
          </li>
        </ul>
      </div>
    </div>

    <!-- Create Group Modal -->
    <el-dialog
      class="border-radius-20 adjustDialog pb-4"
      v-model="displayCreateGroup"
      :width="mdAndUp || lgAndUp || xlAndUp ? '45%' : '90%'"
    >
      <div class="row mt-3">
        <div
          class="col-md-12 text-center text-head text-dark font-weight-bold h2"
        >
          Create group
        </div>
        <div class="col-12">
          <div class="text-dark s-14">Group name</div>
          <el-input class="w-100" v-model="newGroup.name" />
        </div>
        <div class="col-12 mt-4">
          <div class="text-dark s-14">Description</div>
          <textarea
            class="form-control"
            rows="4"
            v-model="newGroup.description"
          ></textarea>
        </div>
      </div>

      <div class="d-flex justify-content-center mt-4 col-md-12">
        <el-button
          round
          class="secondary-button"
          size="large"
          @click="displayCreateGroup = false"
        >
          Cancel
        </el-button>
        <el-button
          round
          class="text-white"
          size="large"
          :color="primarycolor"
          @click="createGroup"
        >
          Create group
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import deviceBreakpoint from "../../../mixins/deviceBreakpoint";
import { ref, inject, watchEffect } from "vue";
import { ElNotification } from "element-plus";
import { useStore } from "vuex";
import axios from "@/gateway/backendapi";

export default {
  name: "GroupTree",
  props: ["items", "addGroupValue", "allChecked", "checked", "autoCheck"],
  emits: ["group", "setcheckval", "resetchecked", "newgroup"],
  setup(props, { emit }) {
    const store = useStore();
    const displayCreateGroup = ref(false);
    const newGroup = ref({ name: "", description: "" });
    const onDropDown = ref(false);
    const multipleGroupsSelected = ref([]);
    const { mdAndUp, lgAndUp, xlAndUp, xsOnly } = deviceBreakpoint();
    const markedItems = ref([]);
    const primarycolor = inject("primarycolor");

    const getCheckedGroup = (item) => {
      const getIndex = multipleGroupsSelected.value.findIndex(
        (j) => j.id === item.id
      );
      if (getIndex < 0) {
        multipleGroupsSelected.value.push(item);
      }
      if (props.autoCheck) checkChildren(item, multipleGroupsSelected.value);
      store.dispatch(
        "groups/setCheckedGroupChildren",
        multipleGroupsSelected.value
      );
      markedItems.value = props.items.filter((i) => i.displayCheck);
    };

    const checkChildren = (item, destArray) => {
      if (item?.children?.length) {
        item.children.forEach((child) => {
          child.displayCheck = item.displayCheck;
          if (item.displayCheck) {
            if (!destArray.find((j) => j.id === child.id)) {
              destArray.push(child);
            }
          }
          if (child.children?.length) checkChildren(child, destArray);
        });
      }
    };

    const checkAll = () => {
      props.items.forEach((i) => {
        i.displayCheck = !!props.allChecked;
        getCheckedGroup(i);
      });
      markedItems.value = props.items.filter((i) => i.displayCheck);
    };

    watchEffect(() => {
      if (props.items.length !== markedItems.value.length) {
        emit("setcheckval", false);
      } else {
        emit("setcheckval", true);
      }

      if (props.checked) {
        checkAll();
        emit("resetchecked", false);
      }

      if (props.addGroupValue) onDropDown.value = true;
    });

    const openCreateGroupModal = () => {
      displayCreateGroup.value = true;
    };

    const createGroup = async () => {
      try {
        let { data } = await axios.post("/api/CreateGroup", newGroup.value);
        ElNotification({
          message: "Group created successfully",
          type: "success",
          duration: 4000,
        });
        displayCreateGroup.value = false;
        newGroup.value = { name: "", description: "" };
        emit("newgroup", data);
      } catch (err) {
        console.error(err);
      }
    };

    const emitGroup = (payload) => emit("group", payload);
    const emitNewGroup = (data) => emit("newgroup", data);

    return {
      mdAndUp,
      lgAndUp,
      xlAndUp,
      xsOnly,
      primarycolor,
      displayCreateGroup,
      newGroup,
      onDropDown,
      multipleGroupsSelected,
      markedItems,
      getCheckedGroup,
      openCreateGroupModal,
      createGroup,
      emitGroup,
      emitNewGroup,
    };
  },
};
</script>

<style scoped>
li {
  list-style-type: none;
}
li:hover {
  background: rgba(224, 223, 223, 0.46);
}
.roll-icon {
  transform: rotate(-90deg);
  transition: all 0.3s ease-in-out;
}
</style>
